export default {
  brand: {
    name: 'Peaks Sports',
    image: '/peaks-logo-white.png',
    route: '/'
  },
  menus: [
    {
      name: 'racesAndEvents',
      items: [
        { name: 'races', route: '/races' },
        { name: 'events', route: '/events' }
      ]
    },
    {
      name: 'about',
      items: [
        { name: 'aboutUs', route: '/about' },
        { name: 'socialGroups', route: '/social/groups' }
      ]
    },
    {
      name: 'register',
      items: [
        { name: 'volunteers', route: '/volunteers' },
        { name: 'partners', route: '/partners' },
        { name: 'sponsors', route: '/sponsors' }
      ]
    },
    {
      name: 'legal',
      items: [
        { name: 'termsConditions', route: '/terms' },
        { name: 'privacyPolicy', route: '/privacy' },
        { name: 'cookies', route: '/cookies' }
      ]
    }
  ]
}
